<template>
    <div class="page">
      <div class="video-wrapper">
        <video id="myVideo" src="" type="video/mp4" controls></video>
      </div>
    </div>
  </template>
        
        
        <script>
  export default {
    props: {
      msg: String,
    },
  
    data() {
      return {
        videoStr: "",
      };
    },

    created(){
      this.init();
    },

    mounted() {
      this.init();
    },

    // activated(){
    //   this.init();
    // },
    methods: {
      init() {
        var video = document.getElementById("myVideo");
        var than = this;
        console.log(this.$route.query.src)
        this.videoStr = this.$route.query.src
        video.addEventListener("ended", function () {
          video.src = than.videoStr;
          video.play();
        });
        video.src = this.videoStr;
        video.play();
      },
    },
  };
  </script>
        
  <style>
  html,
  body,
  #app {
    height: 100%;
    margin: 0;
    padding: 0;
  }
  
  video {
    height: 100%;
    width: 100%;
    position: absolute;
    object-fit: fill;
  } 
  </style>